// Material Dashboard 2 PRO React TS Base Styles
import borders from '@theme/base/borders';

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from '@theme/functions/pxToRem';

const { borderRadius } = borders;

// types
type Types = any;

const cardMedia: Types = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius.xl,
      margin: `${pxToRem(16)} ${pxToRem(16)} 0`
    },

    media: {
      width: 'auto'
    }
  }
};

export default cardMedia;
